import { commonFilter } from './filter';

export default {
  pageName: 'CommunityVideoTagInsight',
  pageId: '2512',
  pagePath: '/opinion/Community/Video?tab=insight',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    METRIC_SELECT: { buttonId: '2512001' },
    ATTRIBUTE_SELECT: { buttonId: '2512002' },
    SEARCH_TAG: { buttonId: '2512003' },
    TAG_TIER_SELECT: { buttonId: '2512004' },
    NAVIGATOR_SELECT: { buttonId: '2512005' },

    ...commonFilter,
  },
  card: {
    TAG_ANALYSIS_CHART: {
      table: {
        buttonId: '2512011',
      },
      line: {
        buttonId: '2512012',
      },
      bar: {
        buttonId: '2512013',
      },
      pie: {
        buttonId: '2512014',
      },
      'common-bar': {
        buttonId: '2512015',
      },
      download: {
        buttonId: '2512016',
      },
    },
  },
};
